import React from "react";

/* ── 일주(60갑자) 동물 캐릭터 이미지 ────────────────────────────────
   public/ilju/ilju_{천간idx}_{지지idx}.png  (사용자 제공 60갑자 캐릭터)   */

const STEM_IDX: Record<string, number> = {
  "甲": 0, "乙": 1, "丙": 2, "丁": 3, "戊": 4, "己": 5, "庚": 6, "辛": 7, "壬": 8, "癸": 9,
};
const BRANCH_IDX: Record<string, number> = {
  "子": 0, "丑": 1, "寅": 2, "卯": 3, "辰": 4, "巳": 5, "午": 6, "未": 7, "申": 8, "酉": 9, "戌": 10, "亥": 11,
};
const STEM_ELEM: Record<string, string> = {
  "甲": "목", "乙": "목", "丙": "화", "丁": "화", "戊": "토",
  "己": "토", "庚": "금", "辛": "금", "壬": "수", "癸": "수",
};
const ELEM_ACC: Record<string, string> = { "목": "#5E8A4E", "화": "#D0654F", "토": "#B8862A", "금": "#9B958A", "수": "#4A7BA8" };
const BRANCH_NAME: Record<string, string> = {
  "子": "쥐", "丑": "소", "寅": "호랑이", "卯": "토끼", "辰": "용", "巳": "뱀",
  "午": "말", "未": "양", "申": "원숭이", "酉": "닭", "戌": "개", "亥": "돼지",
};

/** 천간·지지(한자) → 이미지 경로. 없으면 null */
export function iljuImg(stem: string, branch: string): string | null {
  const si = STEM_IDX[stem], bi = BRANCH_IDX[branch];
  if (si === undefined || bi === undefined) return null;
  return `/ilju/ilju_${si}_${bi}.png`;
}

export function animalInfo(stem: string, branch: string) {
  const el = STEM_ELEM[stem] || "토";
  return { el, acc: ELEM_ACC[el], name: BRANCH_NAME[branch] || "", img: iljuImg(stem, branch) };
}

/** HTML 문맥용 — 원형 캐릭터 이미지 (부모가 크기 지정) */
export function AnimalFace({ stem, branch, size = 36 }: { stem: string; branch: string; size?: number }) {
  const src = iljuImg(stem, branch);
  if (!src) {
    return <div style={{ width: size, height: size, borderRadius: "50%", background: "#ECEAE4" }} />;
  }
  return (
    <img src={src} alt="" width={size} height={size}
      style={{ width: size, height: size, objectFit: "cover", objectPosition: "center 30%", borderRadius: "50%", display: "block" }} />
  );
}
